module.exports = __webpack_public_path__ + "img/Cognitive_option.34590e2a.svg";